"use client";

import { API } from "@/services/api/API";
import { SelectHTMLAttributes, useState, useEffect } from "react";
import type { Municipality } from "@/@types/Municipality";
import type { State } from "@/@types/State";

interface Props extends SelectHTMLAttributes<HTMLSelectElement> {
  autoComplete?: string;
  disabled?: boolean;
  form?: string;
  multiple?: boolean;
  name?: string;
  required?: boolean;
  size?: number;
  value?: string | readonly string[] | number;
  className?: string;
  slug?: string;
  label?: string;
  id?: string;
  labelClass?: string;
}

const SelectInput = ({ slug, label, id, ...props }: Props) => {
  const [statesList, setStatesList] = useState<(Municipality | State)[]>([]);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        if (slug) {
          const result = await fetchApi(`municipalities?stateSlug=${slug}`);
          setStatesList(result);
        } else {
          const result = await fetchApi("states");
          setStatesList(result);
        }
      } catch (err) {
        console.error("Error al cargar los estados.", err);
      }
    };

    const fetchApi = async (option: string): Promise<(Municipality | State)[]> => {
      
      const response = await fetch(`/api/${option}`, { method: "GET" });

      const data : (Municipality | State)[] = await response.json();

      return data;

    };

    fetchStates();
  }, [slug]);

  const extraClass = props.labelClass ?? "mb-2 text-xl text-dark02";

  return (
    <div className="flex flex-col mt-4">
      <label htmlFor={id} className={extraClass}>
        {label}
      </label>
      <select {...props}>
        <option value="">Seleccione...</option>
        {statesList.map((state) => (
          <option key={state.key} value={state.id}>
            {state.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectInput;
